<template>
  <div>
    <CategoryInfoImage :category="category" class="category-info-image" />
    <div class="publication-category-description pt-4 pb-4">
      {{ categoryDescription }}
    </div>
  </div>
</template>

<script>
import CategoryInfoImage from '@/components/views/CategoryView/CategoryInfo/CategoryInfoImage.vue';

export default {
  name: 'CategoryInfo',
  components: { CategoryInfoImage },
  props: {
    category: {
      type: String,
      required: false
    }
  },
  data() {
    return {};
  },
  computed: {
    categoryDescription() {
      const categoryInfo = this.$store.getters['LibraryStore/getCategoryInfo'](
        this.category
      );
      return categoryInfo?.description || '';
    }
  },
  methods: {}
};
</script>

<style lang="less" src="./CategoryInfo.less"></style>
